import { render } from "./WhatMobile.vue?vue&type=template&id=0d625a9e&scoped=true"
import script from "./WhatMobile.vue?vue&type=script&lang=js"
export * from "./WhatMobile.vue?vue&type=script&lang=js"

import "./WhatMobile.vue?vue&type=style&index=0&id=0d625a9e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d625a9e"]])

export default __exports__